<template>
  <sub-page :title="title">
    <div class="js-detail-page">

      <div class="record-sheet" :class="{ 'is-multi': totalPages > 1 }" ref="sheet">
        <div class="sheet-header">
          <div class="main-title"><span class="title-line1">江苏省社会保险权益记录单</span><span class="title-line2">（参保人员）</span></div>
          <div class="qr-wrap">
            <img v-if="qrDataUrl" :src="qrDataUrl" class="qr-img" alt="验证二维码" />
            <div class="qr-tip">请使用官方江苏智慧人社APP扫描验证</div>
          </div>
        </div>

        <!-- 顶部信息表 -->
        <div class="table-scroll">
        <table class="sheet-table info-table" style="margin-top: 10px;">
          <colgroup>
            <col style="width:14%" />
            <col style="width:18%" />
            <col style="width:20%" />
            <col style="width:26%" />
            <col style="width:10%" />
            <col style="width:12%" />
          </colgroup>
          <tbody>
            <tr>
              <td class="lbl">姓名</td>
              <td>{{ base.name }}</td>
              <td class="lbl">公民身份号码<br />（社会保障号）</td>
              <td class="id-cell">{{ base.idNo }}</td>
              <td class="lbl">性别</td>
              <td>{{ base.gender }}</td>
            </tr>
          </tbody>
        </table>
        </div>
        <div class="page-tip">共{{ totalPages }}页，第1页</div>

        <!-- 参加社会保险基本情况 -->
        <div class="table-scroll">
        <table class="sheet-table base-table">
          <colgroup>
            <col style="width:21%" />
            <col style="width:27%" />
            <col style="width:13%" />
            <col style="width:13%" />
            <col style="width:26%" />
          </colgroup>
          <tbody>
            <tr class="group-title">
              <td colspan="5">参加社会保险基本情况</td>
            </tr>
            <tr class="head-row">
              <td>险种</td>
              <td>养老保险</td>
              <td colspan="2">工伤保险</td>
              <td>失业保险</td>
            </tr>
            <tr>
              <td class="lbl">参保状态</td>
              <td>{{ base.statusPension }}</td>
              <td colspan="2">{{ base.statusInjury }}</td>
              <td>{{ base.statusUnemploy }}</td>
            </tr>
            <tr class="fit-row">
              <td class="lbl">现参保单位全称</td>
              <td colspan="2">{{ maskVal(base.companyFull, '单位名称') }}</td>
              <td class="lbl">现参保地</td>
              <td>{{ base.place }}</td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- 主表：出具证明前13个月缴费情况 -->
        <template v-for="(pageRows, pi) in pages">
          <div class="page-tip sub" v-if="pi > 0" :key="'tip-' + pi">共{{ totalPages }}页，第{{ pi + 1 }}页</div>
          <div class="table-scroll">
          <table class="sheet-table main-table" :class="{ 'first-main': pi === 0 }" :key="'tbl-' + pi">
            <colgroup>
              <col style="width:calc(54 * var(--w))" />
              <col style="width:calc(34 * var(--w))" />
              <col style="width:calc(200 * var(--w))" />
              <col style="width:calc(102 * var(--w))" />
              <col style="width:calc(98 * var(--w))" />
              <col style="width:calc(103 * var(--w))" />
              <col style="width:calc(93 * var(--w))" />
              <col style="width:calc(108 * var(--w))" />
              <col style="width:calc(90 * var(--w))" />
            </colgroup>
            <thead v-if="pi === 0">
              <tr class="group-title">
                <td colspan="9">出具证明前{{ monthCount }}个月缴费情况（{{ periodRange }}）</td>
              </tr>
              <tr class="head-row">
                <td rowspan="2">年</td>
                <td rowspan="2">月</td>
                <td rowspan="2">单位全称</td>
                <td colspan="2">养老保险</td>
                <td colspan="2">失业保险</td>
                <td>工伤保险</td>
                <td rowspan="2">备注</td>
              </tr>
              <tr class="head-row sub-head">
                <td>缴费基数（<br />元）</td>
                <td>个人缴<br />费（元）</td>
                <td>缴费基数（<br />元）</td>
                <td>个人缴<br />费（元）</td>
                <td>缴费基数（<br />元）</td>
              </tr>
            </thead>
            <tbody>
              <tr class="data-row" v-for="(row, ri) in pageRows" :key="pi + '-' + ri">
                <td>{{ row.year }}</td>
                <td>{{ row.month }}</td>
                <td class="company">{{ maskVal(row.company, '单位名称') }}</td>
                <td>{{ maskVal(row.pensionBase, '缴费基数') }}</td>
                <td>{{ maskVal(row.pensionPersonal, '个人缴费金额') }}</td>
                <td>{{ maskVal(row.unemployBase, '缴费基数') }}</td>
                <td>{{ maskVal(row.unemployPersonal, '个人缴费金额') }}</td>
                <td>{{ maskVal(row.injuryBase, '缴费基数') }}</td>
                <td>{{ row.remark }}</td>
              </tr>
              <tr v-if="displayRows.length === 0">
                <td colspan="9" class="empty-row">所选年月范围内暂无缴费记录</td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="seal-block mid" v-if="pi < totalPages - 1" :key="'seal-' + pi">
            <img :src="sealImg" class="seal-img" alt="电子专用章" />
            <div class="seal-info">
              <div class="seal-mark">(盖章)</div>
              <div class="seal-time">{{ sealDate }}</div>
            </div>
          </div>
        </template>

        <!-- 说明（最后一页）：说明：独占一行，1/2/3条各自折行展示 -->
        <div class="remark">
          <p>说明：</p>
          <p>1.本权益记录信息为打印时参保情况，供参考，由参保人员自行保管。</p>
          <p>2.本权益单已签具电子印章，不再加盖鲜章。</p>
          <p>3.本权益记录单出具后有效期限（6个月内），如需核对真伪的，请使用江苏智慧人社APP，扫描右上方二维码进行验证（可多次验证）。</p>
        </div>

        <div class="seal-block" :class="{ 'last-multi': totalPages > 1 }">
          <img :src="sealImg" class="seal-img" alt="电子专用章" />
          <div class="seal-info">
            <div class="seal-mark">(盖章)</div>
            <div class="seal-time">打印时间：{{ sealDate }}</div>
          </div>
        </div>
      </div>

      <!-- 底部全宽灰色操作带：仅APP内显示，扫一扫托管页环境隐藏保存功能 -->
      <div class="sheet-footer" v-if="!isShareHost">
        <button class="save-btn" :disabled="saving" @click="saveImage">{{ saving ? '正在生成…' : '保存为图片' }}</button>
      </div>

      <!-- APP环境：全屏图片预览，长按可保存到相册（点击空白关闭） -->
      <div class="img-preview-mask" v-if="showPreviewImg" @click="showPreviewImg = false">
        <div class="img-preview-tip">长按图片可保存到相册，点击空白处关闭</div>
        <img :src="previewImg" class="img-preview-img" alt="权益记录单" />
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import html2canvas from 'html2canvas'
import sealImg from '../assets/icons/electronic-seal-trans.png'
import { buildShareUrl, generateQrDataUrl } from '../utils/share'

// 精确到分（2位小数）的四舍五入，加 Number.EPSILON 修正浮点误差
function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100
}

// 截图前把区域内非data图片（本地印章）带重试地转成 dataURL，完成后返回还原函数
function inlineImages(root) {
  const nodes = Array.from(root.querySelectorAll('img')).filter(img => !/^data:/i.test(img.src))
  return Promise.all(nodes.map(img => new Promise(resolve => {
    const original = img.src
    let n = 0
    const load = () => {
      n++
      const im = new Image()
      im.crossOrigin = 'anonymous'
      let settled = false
      const timer = setTimeout(fail, 3000)
      function fail() {
        if (settled) return
        settled = true
        clearTimeout(timer)
        if (n < 3) setTimeout(load, 200)
        else resolve()
      }
      im.onload = () => {
        if (settled) return
        settled = true
        clearTimeout(timer)
        try {
          const c = document.createElement('canvas')
          c.width = im.naturalWidth
          c.height = im.naturalHeight
          c.getContext('2d').drawImage(im, 0, 0)
          img.src = c.toDataURL('image/png')
          img.dataset.origSrc = original
        } catch (e) { /* 跨域被拒则保留原地址 */ }
        resolve()
      }
      im.onerror = fail
      im.src = original
    }
    load()
  }))).then(() => () => {
    root.querySelectorAll('img[data-orig-src]').forEach(img => {
      img.src = img.dataset.origSrc
      delete img.dataset.origSrc
    })
  })
}

// 数据末端：与 SocialInsuranceDetail 月度记录一致（2026年8月）
const DATA_END_YM = '202608'
// 数据起点：2016年10月
const DATA_START_YM = '201610'

// 每年7月调整缴费基数（社保年度）；早于2016年取最早已知基数，晚于2025年取最新基数
function baseOfYear(y) {
  const map = {
    2016: '2628.00',
    2017: '2940.00',
    2018: '3125.00',
    2019: '3368.00',
    2020: '3368.00',
    2021: '3800.00',
    2022: '4250.00',
    2023: '4494.00',
    2024: '4879.00',
    2025: '4952.00'
  }
  if (y < 2016) return map[2016]
  return map[y] || map[2025]
}

// 当前缴费单位（2020年7月起）
const COMPANY_CURRENT = '江苏超芯星半导体有限公司'
const COMPANY_EARLY = '中储科技有限公司'

// 生成单个月的缴费记录（月份补零显示为2位数）
function buildRow(y, m) {
  // 社保年度：每年7月起用新基数
  const base = baseOfYear(m >= 7 ? y : y - 1)
  const b = parseFloat(base)
  return {
    ym: `${y}${String(m).padStart(2, '0')}`,
    year: String(y),
    month: String(m).padStart(2, '0'),
    company: (y > 2020 || (y === 2020 && m >= 7)) ? COMPANY_CURRENT : COMPANY_EARLY,
    pensionBase: base,
    pensionPersonal: round2(b * 0.08).toFixed(2),
    unemployBase: base,
    unemployPersonal: round2(b * 0.005).toFixed(2),
    injuryBase: base,
    remark: ''
  }
}

// 生成2016年10月至2026年9月的按月缴费记录
export function buildAllRows() {
  const rows = []
  let y = parseInt(DATA_START_YM.substring(0, 4))
  let m = parseInt(DATA_START_YM.substring(4, 6))
  const endY = parseInt(DATA_END_YM.substring(0, 4))
  const endM = parseInt(DATA_END_YM.substring(4, 6))
  while (y < endY || (y === endY && m <= endM)) {
    rows.push(buildRow(y, m))
    m++
    if (m > 12) { m = 1; y++ }
  }
  return rows
}

export default {
  name: 'JiangsuSocialInsured',
  components: { SubPage },
  data() {
    return {
      sealImg,
      title: '个人权益记录查询打印',
      // 保存图片相关状态
      saving: false,        // 是否正在生成
      showPreviewImg: false,// APP环境是否显示图片预览
      previewImg: '',       // 生成的图片DataURL
      qrDataUrl: '',        // 动态二维码图片dataURL
      // 查询页选择的起止年月
      startDate: this.$route.query.start || DATA_START_YM,
      endDate: this.$route.query.end || DATA_END_YM,
      // 需脱敏的字段（来自查询页勾选）
      maskList: (this.$route.query.mask || '').split(',').filter(Boolean),
      base: {
        name: '戴义杰',
        gender: '男',
        idNo: '341122199210285619',
        statusPension: '暂停缴费（中断）',
        statusInjury: '暂停缴费（中断）',
        statusUnemploy: '暂停缴费（中断）',
        companyFull: '南京市江北新区暂时中止单位',
        place: '江北新区'
      }
    }
  },
  computed: {
    // 扫一扫托管页环境（https且非本机）：隐藏「保存为图片」等APP内功能
    isShareHost() {
      return location.protocol.indexOf('http') === 0 &&
        location.hostname !== 'localhost' &&
        location.hostname !== '127.0.0.1'
    },
    sealDate() {
      const now = new Date()
      return `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日`
    },
    // 按查询起止年月动态生成月度记录（超出真实数据末端时截断）
    displayRows() {
      if (!/^\d{6}$/.test(this.startDate) || !/^\d{6}$/.test(this.endDate)) return []
      const cappedEnd = this.endDate > DATA_END_YM ? DATA_END_YM : this.endDate
      if (this.startDate > cappedEnd) return []
      const rows = []
      let y = parseInt(this.startDate.substring(0, 4))
      let m = parseInt(this.startDate.substring(4, 6))
      const eY = parseInt(cappedEnd.substring(0, 4))
      const eM = parseInt(cappedEnd.substring(4, 6))
      while (y < eY || (y === eY && m <= eM)) {
        rows.push(buildRow(y, m))
        m++
        if (m > 12) { m = 1; y++ }
      }
      return rows
    },
    // 每页30行分页（按设计稿多页场景每页展示更多数据）
    pages() {
      const size = 30
      const rows = this.displayRows
      if (rows.length === 0) return [[]]
      const list = []
      for (let i = 0; i < rows.length; i += size) {
        list.push(rows.slice(i, i + size))
      }
      return list
    },
    totalPages() {
      return this.pages.length
    },
    // 主表标题中的起止区间文案
    periodRange() {
      return `${this.startDate}-${this.endDate}`
    },
    // 标题中的月数：按起止年月动态计算（含首尾月）
    monthCount() {
      if (!/^\d{6}$/.test(this.startDate) || !/^\d{6}$/.test(this.endDate)) return 0
      if (this.startDate > this.endDate) return 0
      const y = parseInt(this.startDate.substring(0, 4))
      const m = parseInt(this.startDate.substring(4, 6))
      const eY = parseInt(this.endDate.substring(0, 4))
      const eM = parseInt(this.endDate.substring(4, 6))
      return (eY - y) * 12 + (eM - m) + 1
    }
  },
  mounted() {
    // 动态二维码：按起止年月、脱敏字段生成（参数变化时刷新）
    this.refreshQr()
    // 表格自适应：字体加载后及窗口尺寸变化时重新收缩适配（与SocialInsuranceDetail一致）
    this.$nextTick(this.fitCells)
    setTimeout(this.fitCells, 350)
    // 字体真正就绪后再测一次：保证用 RSJ Sans 度量计算内联px，与浏览器结果一致
    if (document.fonts && document.fonts.ready) {
      this._onFontsReady = () => this.$nextTick(this.fitCells)
      document.fonts.ready.then(this._onFontsReady)
    }
    window.addEventListener('resize', this.fitCells)
    window.addEventListener('orientationchange', this.fitCells)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fitCells)
    window.removeEventListener('orientationchange', this.fitCells)
  },
  watch: {
    // 查询条件变化/分页重算后重新适配并刷新二维码
    '$route'() {
      this.refreshQr()
      this.$nextTick(this.fitCells)
      setTimeout(this.fitCells, 350)
    }
  },
  methods: {
    // 生成动态二维码：内容为托管页 URL，携带起止年月与脱敏字段，扫码后还原本页
    async refreshQr() {
      try {
        const url = buildShareUrl('/jiangsu-social-insured', this.startDate, this.endDate, this.maskList)
        this.qrDataUrl = await generateQrDataUrl(url)
      } catch (e) { /* 生成失败保留空白，不阻塞页面 */ }
    },
    // 收缩适配：目标单元格强制单行，宽度不够时逐档缩小字号，杜绝APK折行
    fitCells() {
      const sheet = this.$refs.sheet
      if (!sheet) return
      const els = sheet.querySelectorAll('.info-table td.id-cell, .base-table tr.fit-row td, .main-table .data-row td')
      // 先全部恢复样式表默认字号并强制单行
      els.forEach(el => {
        el.style.whiteSpace = 'nowrap'
        el.style.fontSize = ''
      })
      // 强制回流后逐档收缩
      void sheet.offsetWidth
      els.forEach(el => {
        let fs = parseFloat(getComputedStyle(el).fontSize)
        let guard = 0
        while (el.scrollWidth > el.clientWidth && fs > 9 && guard < 40) {
          fs -= 0.5
          el.style.fontSize = fs + 'px'
          guard++
        }
        // 缩到下限仍溢出：放弃单行允许自然换行，杜绝内容横向覆盖相邻列
        if (el.scrollWidth > el.clientWidth) {
          el.style.whiteSpace = 'normal'
        }
      })
      // 标题：按设计稿墨稿宽度（第一行403w/第二行165w）反推字号，
      // 自动补偿不同环境字体advance差异（内嵌浏览器CJK达1.167em），保证几何一致
      const titleLine = sheet.querySelector('.title-line1')
      const titleLine2 = sheet.querySelector('.title-line2')
      const qrSvg = sheet.querySelector('.qr-img')
      if (titleLine && qrSvg) {
        const wpx = window.innerWidth / 1080
        // 恢复默认字号，实测当前环境字体advance比
        titleLine.style.fontSize = ''
        const baseFs = parseFloat(getComputedStyle(titleLine).fontSize)
        const ratio = titleLine.getBoundingClientRect().width / (11 * baseFs)
        let tfs = (403 * wpx / 11) / ratio
        titleLine.style.fontSize = tfs + 'px'
        // 第二行：6个全宽字目标165w
        if (titleLine2) {
          titleLine2.style.fontSize = (165 * wpx / 6) / ratio + 'px'
        }
        // 安全兜底：若右缘离二维码不足4px，以0.5px步长继续收缩
        let guard = 0
        while (titleLine.getBoundingClientRect().right + 4 > qrSvg.getBoundingClientRect().left && tfs > 14 && guard < 40) {
          tfs -= 0.5
          titleLine.style.fontSize = tfs + 'px'
          guard++
        }
      }
    },
    // 字段需脱敏则返回 ***，否则返回原值
    maskVal(value, field) {
      return this.maskList.includes(field) ? '***' : value
    },
    // 将权益记录单生成为图片并保存
    async saveImage() {
      if (this.saving) return
      this.saving = true
      // 先把印章等转成 dataURL（带重试），保证导出图与当前页面一致；返回还原函数
      const restore = await inlineImages(this.$refs.sheet)
      html2canvas(this.$refs.sheet, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false
      }).then(canvas => {
        const dataUrl = canvas.toDataURL('image/png')
        // Cordova APP 内 a.download 不生效：弹出大图供用户长按保存到相册
        if (window.cordova) {
          this.previewImg = dataUrl
          this.showPreviewImg = true
        } else {
          // 浏览器环境：触发文件下载
          const link = document.createElement('a')
          link.download = '江苏省社会保险权益记录单（参保人员）.png'
          link.href = dataUrl
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }).catch(err => {
        alert('图片生成失败：' + (err && err.message ? err.message : err))
      }).then(() => {
        this.saving = false
        restore()
      })
    }
  }
}
</script>

<style scoped>
.js-detail-page {
  background: #FFFFFF;
  min-height: 100%;
  flex: 1;
  /* 纵向弹性：底部灰带在内容不足一屏时自动填满剩余高度 */
  display: flex;
  flex-direction: column;
}
.record-sheet {
  position: relative;
  background: #FFFFFF;
  width: 90%;
  margin: 0 auto;
  /* 底部留白：印章后到纸边（单页约520w） */
  padding: calc(10 * var(--w)) calc(10 * var(--w)) calc(520 * var(--w));
}
/* 多页场景底部留白约600w */
.record-sheet.is-multi {
  padding-bottom: calc(600 * var(--w));
}
.sheet-header {
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
  /* 设计稿header流程高224w */
  height: calc(224 * var(--w));
}
/* 标题整体绝对定位：设计稿标题中心为x=484（相对居中的sheet中心540左移56w），
   不随二维码/表格宽度变化 */
.main-title {
  position: absolute;
  left: 50%;
  margin-left: calc(-56 * var(--w));
  transform: translateX(-50%);
  top: calc(64 * var(--w));
  text-align: center;
  font-weight: bold;
  color: #323233;
  white-space: nowrap;
}
/* 第一行：设计稿字号约36w，墨稿281-684（宽403），不折行，
   极端情况下由JS测量收缩避免压住二维码 */
.title-line1 {
  display: block;
  font-size: calc(37 * var(--w));
  line-height: 1.2;
}
/* 第二行：设计稿字号明显小于第一行（约30w），墨稿402-567，与第一行同中心 */
.title-line2 {
  display: block;
  font-size: calc(30 * var(--w));
  line-height: 1.2;
  margin-top: calc(14 * var(--w));
}
.qr-wrap {
  /* 绝对定位脱离文档流：不挤占标题宽度，使标题相对整页居中 */
  position: absolute;
  /* 设计稿：二维码顶在header顶下方39w */
  top: calc(39 * var(--w));
  /* 右缘对齐设计稿x=878（视口81.3%）：原right:0与表格右缘齐平，左移138w */
  right: 0px;
  width: calc(240 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.qr-img {
  width: calc(143 * var(--w));
  height: calc(143 * var(--w));
  bottom: 5px;
}
.qr-tip {
  font-size: calc(17 * var(--w));
  color: #323233;
  /* 二维码底到提示文字顶：设计稿39w，取35w使提示底距信息表顶6w */
  margin-top: calc(35 * var(--w));
  /* 不设宽度/负边距：随父级flex（align-items:flex-end）右缘与二维码对齐 */
  line-height: 1.1;
  white-space: nowrap;
}
.page-tip {
  text-align: right;
  font-size: calc(22 * var(--w));
  color: #323233;
  margin: calc(6 * var(--w)) 0 calc(8 * var(--w));
}
.page-tip.sub {
  margin-top: calc(36 * var(--w));
  margin-bottom: calc(12 * var(--w));
}
/* 表格横向滚动兜底：列多/极端字体/窄屏下内容横向滚动而不折行重叠（滚动条已全局隐藏） */
.table-container {
  width: 100%;
}
.table-scroll {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.sheet-table {
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
}
/* 主表：固定882w宽并居中（设计稿表格x98-980），不随内容盒拉伸 */
.main-table {
  /* width: calc(882 * var(--w)); */
  margin-left: auto;
  margin-right: auto;
}
/* 首个主表与基本情况表无缝相接：collapse下td自带四边框，
   需去掉首行td的顶边框，交界只保留前表底边框一道（否则叠加成2px） */
.main-table.first-main tr:first-child td {
  border-top: none;
}
/* 养老/失业表头已用 colspan=2 合并，grp-l/grp-r 样式移除 */
.sheet-table th,
.sheet-table td {
  
  border: 1px solid #1a1a1a;
  text-align: center;
  vertical-align: middle;
  /* 基准字号23w：设计稿1080画布中数字字高17px(=0.733em)，w单位随屏幕/DPR自适应，恒等于设计稿 */
  font-size: calc(23 * var(--w)) !important;
  /* 显式常规字重：实测APK曾以bold渲染数据(笔画密度23.5% vs 设计稿11.3%)，强制normal杜绝加粗显大 */
  font-weight: normal;
  color: #1a1a1a;
  padding: calc(3 * var(--w)) calc(2 * var(--w));
  line-height: 1.1;
  word-break: break-all;
  overflow-wrap: break-word;
  -webkit-font-smoothing: antialiased;
}
.sheet-table td.text-left {
  text-align: left;
  padding-left: calc(8 * var(--w));
}
/* 主表单位全称列（单页场景）：设计稿汉字字高14px(0.92em)=15w，单行不折行 */
.main-table .data-row td.company {
  text-align: center;
  font-size: calc(15 * var(--w)) !important;
  font-weight: normal;
  padding-left: calc(1 * var(--w));
  padding-right: calc(1 * var(--w));
}
.sheet-table td.empty-row {
  padding: calc(40 * var(--w)) calc(6 * var(--w));
  color: #969799;
}
/* 各表独立包裹于table-scroll，相邻去重规则不再适用（selectors已无法命中），删除 */
/* 顶部信息表：行高44w，字号统一16w对齐设计稿 */
.info-table td {
  height: calc(44 * var(--w));
  font-size: calc(16 * var(--w)) !important;
  font-weight: normal;
  padding: calc(2 * var(--w)) calc(2 * var(--w));
}
.info-table td.id-cell {
  font-size: calc(16 * var(--w)) !important;
  font-weight: normal;
  letter-spacing: calc(-0.2 * var(--w));
  white-space: nowrap;
}
.info-table td.lbl {
  font-size: calc(16 * var(--w)) !important;
  font-weight: bold;
}
/* 参加社会保险基本情况表：对齐设计稿（四行高约40-42px=41w，设计稿584-748） */
.base-table tr {
  height: calc(41 * var(--w));
}
.base-table td {
  /* 数据值：设计稿汉字字高13-14px(0.92em)=15w */
  font-size: calc(15 * var(--w)) !important;
  font-weight: normal;
  padding: calc(2 * var(--w)) calc(2 * var(--w));
}
/* 表头行（险种/养老保险/工伤保险/失业保险）：bold，设计稿汉字字高16-17px=18w */
.base-table .head-row td {
  font-size: calc(18 * var(--w)) !important;
  font-weight: bold;
}
/* 标签列（参保状态/现参保单位全称/现参保地）：bold，设计稿汉字字高16-17px=18w */
.base-table td.lbl {
  font-size: calc(18 * var(--w)) !important;
  font-weight: bold;
}
/* 组标题行：加粗居中 */
.group-title td {
  font-weight: bold;
  /* 组标题字高20px=24w，行高40w（设计稿748-788） */
  font-size: calc(24 * var(--w));
  text-align: center;
  height: calc(40 * var(--w));
}
/* 主表组标题行（出具证明前…）：设计稿字高约20px=22w，行高27w（788-815）；
   基本情况表的.group-title行(40w)不受影响 */
.main-table .group-title td {
  font-size: calc(19 * var(--w));
  height: calc(27 * var(--w));
}
/* 主表一级表头（单页）：bold，设计稿汉字字高15px(0.92em)=16w，行高24w */
.main-table .head-row td {
  height: calc(24 * var(--w));
  font-size: calc(16 * var(--w)) !important;
  font-weight: bold;
}
/* 主表二级表头（单页）：bold，同16w，行高24w（thead合计27+24+24=75w=设计稿788-863） */
.main-table .sub-head td {
  height: calc(24 * var(--w));
  font-size: calc(16 * var(--w)) !important;
  font-weight: bold;
  line-height: 1.1;
}
/* 月度数据行行高约26w（设计稿863-889），设计稿数字字高10px(0.746em)/汉字14px(0.92em)=15w；
   强制单行不折行（设计稿数据均单行） */
.main-table .data-row td {
  height: calc(26 * var(--w));
  font-size: calc(15 * var(--w)) !important;
  font-weight: normal;
  padding: calc(2 * var(--w)) calc(3 * var(--w));
  white-space: nowrap;
  word-break: normal;
  overflow-wrap: normal;
}
/* 主表「年」列(首列)：与数据行统一15w，单行 */
.main-table .data-row td:first-child {
  white-space: nowrap;
  font-size: calc(15 * var(--w)) !important;
}
/* ===== 多页场景（record-sheet.is-multi）：对齐多页设计稿 ===== */
/* 数据行：行高41w，数字字高11px(0.746em)=15w，常规字重 */
.record-sheet.is-multi .main-table .data-row td {
  height: calc(41 * var(--w));
  font-size: calc(15 * var(--w)) !important;
  font-weight: normal;
}
/* 年列同步15w，保持单行 */
.record-sheet.is-multi .main-table .data-row td:first-child {
  font-size: calc(15 * var(--w)) !important;
}
/* 单位全称列：汉字字高14px(0.92em)=15w */
.record-sheet.is-multi .main-table .data-row td.company {
  font-size: calc(15 * var(--w)) !important;
  font-weight: normal;
}
/* 多页表头仅在第一页显示（v-if="pi===0"），字号与单页一致 */
.remark {
  /* 与上方表格的间距按设计稿 */
  /* margin-top: calc(40 * var(--w)); */
  font-size: calc(22 * var(--w));
  color: #323233;
  line-height: 1.9;
  margin-bottom:-24px;
}
.remark p {
  margin: 0;
}
.seal-block {
  position: relative;
  width: fit-content;
  /* 印章顶比说明文字底高约13w（设计稿x不重叠，可与末行说明齐平） */
  margin-top: calc(-19 * var(--w));
  margin-left: auto;
  /* 印章右缘=933w(视口86.4%)：内容盒右缘1016w - margin-right 83w */
  margin-right: calc(83 * var(--w));
}
/* 中间页印章：上浮与表格底部略重叠（按设计稿位置再向下偏移），仅显示章不显示日期 */
.seal-block.mid {
  margin-top: -32px;
  margin-bottom: calc(60 * var(--w));
}
/* 多页场景末页印章：与单页同样的位置（顶比说明底高13w） */
.seal-block.last-multi {
  margin-top: calc(-19 * var(--w));
}
.seal-block.mid .seal-time {
  display: none;
}
.seal-img {
  margin-top: 10px;
  position: relative;
  z-index: 2;
  width: calc(196 * var(--w));
  height: calc(196 * var(--w));
  display: block;
}
.seal-info {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.seal-mark {
  position: absolute;
  /* 位于印章几何中心，被五角星覆盖（仅括号尖微露） */
  top: calc(50% - calc(12 * var(--w)));
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 2px;
  font-size: calc(19 * var(--w));
  color: #000;
  line-height: 1.4;
  white-space: nowrap;
}
.seal-time {
  margin-top: 2px;
  position: absolute;
  /* 横排穿过印章中部偏下（设计稿）：中心比印章几何中心左41w、低12w（实测margin折叠后），
     与“电子专用章”中心间距36w、字形净间隙13w；左端伸出印章左缘、右端在印章内 */
  top: calc(50% + calc(12 * var(--w)));
  left: calc(50% - calc(41 * var(--w)));
  right: auto;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  font-size: calc(17 * var(--w));
  color: #000;
  line-height: 1.4;
}
.save-btn {
  display: block;
  width: calc(480 * var(--w));
  height: calc(96 * var(--w));
  background: #1E7FFE;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(48 * var(--w));
  margin: 0 auto;
  cursor: pointer;
}
/* 底部全宽灰色操作带：按钮距灰带顶约73w（同设计稿） */
.sheet-footer {
  background: #F8F8F8;
  padding: calc(73 * var(--w)) 0;
  /* 内容不足一屏时灰带向下填满，按钮位置不变 */
  flex: 1;
}
.save-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
/* APP环境图片预览遮罩 */
.img-preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.85);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: calc(40 * var(--w));
}
.img-preview-tip {
  color: #fff;
  font-size: calc(28 * var(--w));
  margin-bottom: calc(30 * var(--w));
}
.img-preview-img {
  max-width: 100%;
  max-height: 75vh;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/JiangsuSocialInsured.vue